import React, { useState } from "react";
import { Link } from "react-router-dom";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import blogsData from "../../api/blogs";
import VideoModal from "../ModalVideo/VideoModal";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const POSTS_PER_PAGE = 3;

const BlogList = (props) => {

  const [filteredBlogs, setFilteredBlogs] = useState(blogsData);
  const [currentPage, setCurrentPage] = useState(1);

  // pagination logic
  const indexOfLast = currentPage * POSTS_PER_PAGE;
  const indexOfFirst = indexOfLast - POSTS_PER_PAGE;
  const currentBlogs = filteredBlogs.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredBlogs.length / POSTS_PER_PAGE);

  // generate short description
  const getExcerpt = (content) => {
    return content.replace(/<[^>]*>/g, "").slice(0, 140) + "...";
  };

  return (
    <section className={props.Qclass}>
      <div className="container-fluid">
        <div className="wpo-blog-wraper">

          {/* BLOG LIST */}
          <div className="wpo-blog-content">

            {currentBlogs.map((blog, i) => (
              <div className={`post format-standard-image ${blog.blClass}`} key={i}>
                <div className="entry-media">
                  <img src={blog.blogSingleImg} alt="" />
                  <VideoModal />
                </div>

                <div className="entry-details">
                  <div className="entry-meta">
                    <ul>
                      <li>By: <Link to="/blog">Luxrock Realty</Link></li>
                      <li>Date: {blog.create_at}</li>
                    </ul>
                  </div>

                  <h3>
                    <Link onClick={ClickHandler} to={`/our-blogs/${blog.slug}`}>
                      {blog.title}
                    </Link>
                  </h3>

                  <p>{getExcerpt(blog.content)}</p>

                  <Link
                    onClick={ClickHandler}
                    to={`/our-blogs/${blog.slug}`}
                    className="read-more"
                  >
                    Read More..
                  </Link>
                </div>
              </div>
            ))}

            {/* PAGINATION */}
            <div className="pagination-wrapper">
              <ul className="pg-pagination">

                <li>
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(p => p - 1)}
                  >
                    <i className="fi ti-arrow-left left"></i>
                  </button>
                </li>

                {[...Array(totalPages)].map((_, i) => (
                  <li key={i} className={currentPage === i + 1 ? "active" : ""}>
                    <button onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li>
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(p => p + 1)}
                  >
                    <i className="fi ti-arrow-right"></i>
                  </button>
                </li>

              </ul>
            </div>

          </div>

          {/* SIDEBAR */}
          <BlogSidebar
            blogs={blogsData}
            setFilteredBlogs={(data) => {
              setFilteredBlogs(data);
              setCurrentPage(1);
            }}
          />

        </div>
      </div>
    </section>
  );
};

export default BlogList;
